import { render, staticRenderFns } from "./VideoPlayerComponent.vue?vue&type=template&id=31fff53e&scoped=true&"
import script from "./VideoPlayerComponent.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerComponent.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerComponent.vue?vue&type=style&index=0&id=31fff53e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fff53e",
  null
  
)

export default component.exports